import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiRequest } from "../utils/api";
import FormFeedback, { FieldError, inputErrorClass } from "./Common/FormFeedback";
import "./LoginRegister.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [validationErrors, setValidationErrors] = useState([]);

  function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    setSuccess(false);
    setError(false);
    setFieldErrors({});
    setValidationErrors([]);

    const formData = new FormData();
    formData.append("email", email);

    apiRequest("/forgot-password", {
      method: "POST",
      body: formData,
    })
      .then((data) => {
        setIsLoading(false);
        setSuccess(data.message || "Password reset email sent successfully.");
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.data?.status === "validation_error") {
          setValidationErrors(error.messages);
          setFieldErrors(error.errors);
        } else {
          setError(error.message);
        }
      });
  }

  return (
    <section className="login-section auth-page">
      <div className="outer-box">
        <div className="login-form default-form auth-login-form">
          <div className="form-inner">
            <h3>Forgot Password</h3>
            <FormFeedback success={success} error={error} validationErrors={validationErrors} />

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  className={inputErrorClass(fieldErrors, "email")}
                  placeholder="Email"
                  required
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <FieldError errors={fieldErrors} name="email" />
              </div>

              <div className="form-group">
                <button className="theme-btn btn-style-one" type="submit" disabled={isLoading}>
                  {isLoading ? "Sending..." : "Send Reset Link"}
                </button>
              </div>
            </form>

            <div className="bottom-box">
              <div className="text">
                <Link className="call-modal signup" to="/login">Back to Login</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
